export enum AnalyticsEvents {
    AddPaymentInfo = 'AddPaymentInfo',
    Lead = 'Lead',
    InitiateCheckout = 'InitiateCheckout',
    Schedule = 'Schedule',
    SubmitApplication = 'SubmitApplication',
    Purchase = 'Purchase'
}
